import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CompareContext = createContext(null);
const KEY = "gk_compare";
const MAX = 4;

function pick(p) {
  return {
    id: p.id, slug: p.slug, product_name: p.product_name || p.title, title: p.title,
    image_url: p.image_url, price: p.price, original_price: p.original_price || "",
    discount_percent: p.discount_percent || 0, store_name: p.store_name || "",
    rating: p.rating, category: p.category || "",
    pros: p.pros || [], cons: p.cons || [], verdict: p.verdict || "", summary: p.summary || p.description || "",
    best_for: p.best_for || "",
    affiliate_url: p.affiliate_url || "",
    kind: p.kind || (p.product_name ? "review" : "deal"),
  };
}

export function CompareProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const has = (id) => items.some((i) => i.id === id);

  const toggle = (product) => {
    if (has(product.id)) { setItems((arr) => arr.filter((i) => i.id !== product.id)); return; }
    if (items.length >= MAX) { toast.error(`You can compare up to ${MAX} products at once`); return; }
    if (items.length > 0 && items[0].category !== (product.category || "")) {
      toast.error("You can only compare products of the same type"); return;
    }
    setItems((arr) => [...arr, pick(product)]);
    toast.success("Added to compare");
  };

  const remove = (id) => setItems((arr) => arr.filter((i) => i.id !== id));
  const clear = () => setItems([]);
  const replace = (products) => setItems(products.slice(0, MAX).map(pick));

  return (
    <CompareContext.Provider value={{ items, toggle, remove, clear, replace, has, max: MAX }}>
      {children}
    </CompareContext.Provider>
  );
}

export const useCompare = () => useContext(CompareContext);
